import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { ButtonComponent } from '@cue/assist/ui/buttons';
import { DropdownlistComponent } from '@cue/assist/ui/dropdowns';
import { translation } from '@cue/translations';
import { cueDelete } from '@cue/ui/icons';
import { TooltipDirective } from '@cue/ui/tooltips';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  NewReservationAttendeeParticipation,
  NewReservationAttendeeRow,
  NewReservationParticipationOption,
} from '../new-reservation-dialog.models';

type NewReservationAttendeeParticipationChange = {
  email: string;
  participation: NewReservationAttendeeParticipation | NewReservationParticipationOption;
};

@Component({
  selector: 'assist-new-reservation-attendee-item',
  templateUrl: './new-reservation-attendee-item.component.html',
  styleUrl: './new-reservation-attendee-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, DropdownlistComponent, TooltipDirective, TranslocoPipe],
})
export class NewReservationAttendeeItemComponent {
  readonly attendee = input.required<NewReservationAttendeeRow>();
  readonly editable = input(false);
  readonly participationOptions = input.required<NewReservationParticipationOption[]>();

  readonly participationChange = output<NewReservationAttendeeParticipationChange>();
  readonly removeAttendee = output<string>();

  readonly translation = translation;
  readonly icons = {
    cueDelete,
  };

  onParticipationChange(participation: NewReservationAttendeeParticipation | NewReservationParticipationOption) {
    this.participationChange.emit({
      email: this.attendee().email,
      participation,
    });
  }

  onRemoveAttendee(event: Event) {
    event.preventDefault();
    this.removeAttendee.emit(this.attendee().email);
  }
}
